var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 163.287C130.475 163.287 163.287 130.475 163.287 90C163.287 49.5246 130.475 16.7129 90 16.7129C49.5246 16.7129 16.7129 49.5246 16.7129 90C16.7129 130.475 49.5246 163.287 90 163.287Z",
    fill: "#FFF8F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 150.826C123.593 150.826 150.826 123.593 150.826 90C150.826 56.4069 123.593 29.1743 90 29.1743C56.4069 29.1743 29.1743 56.4069 29.1743 90C29.1743 123.593 56.4069 150.826 90 150.826Z",
    fill: "#FFEEE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9623 123.522C108.497 123.522 123.523 108.497 123.523 89.962C123.523 71.4271 108.497 56.4016 89.9623 56.4016C71.4274 56.4016 56.4019 71.4271 56.4019 89.962C56.4019 108.497 71.4274 123.522 89.9623 123.522Z",
    fill: "#FC5719"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9611 133.922C65.7208 133.922 46 114.201 46 89.9612C46 65.7209 65.7208 46 89.9611 46C114.201 46 133.922 65.7209 133.922 89.9612C133.922 114.201 114.201 133.922 89.9611 133.922ZM89.9611 50.9583C68.455 50.9583 50.9583 68.4549 50.9583 89.9612C50.9583 111.467 68.455 128.964 89.9611 128.964C111.467 128.964 128.964 111.467 128.964 89.9612C128.964 68.4549 111.467 50.9583 89.9611 50.9583Z",
    fill: "#6A250B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9769 107.557L71.0068 92.4224L77.4628 86.4631L84.5296 94.1187L102.079 72.3674L108.917 77.8845L84.9769 107.557Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4ff69af784f882027869f328e7679ed6.svg";
export { ForwardRef as ReactComponent };